// FILE: src/Comman Components/Images.js (FULLY UPDATED)
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { getProfileAvatarUrl } from '../utils/profileAvatar';

const getInitials = (name = '') => {
  if (!name) return '?';
  const words = name.trim().split(' ').filter(Boolean);
  if (words.length > 1) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

const FallbackAvatar = ({ name, className = 'w-9 h-9 rounded-full' }) => {
  const initials = getInitials(name);
  const hashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };

  const colors = [
    'bg-blue-200 text-blue-800',
    'bg-green-200 text-green-800',
    'bg-purple-200 text-purple-800',
    'bg-yellow-200 text-yellow-800',
    'bg-red-200 text-red-800',
  ];

  const colorClass = colors[Math.abs(hashCode(name || '')) % colors.length];

  return (
    <div
      className={`${className} flex items-center justify-center font-bold text-xs ${colorClass}`}
    >
      {initials}
    </div>
  );
};

export default function Images({
Id,
fallbackName = null,
fallbackImageUrl = null,
className = 'w-9 h-9 rounded-full object-cover',
}) {
  const profileDetails = useSelector((state) => state.groups.profileDetails[Id]);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [
    Id,
    profileDetails?.profile_picture_blob_url,
    profileDetails?.profile_picture_version,
    profileDetails?.profile_picture_url,
    profileDetails?.profile_image,
  ]);

  if (!profileDetails) {
if (fallbackImageUrl) {
return (
<img
src={fallbackImageUrl}
alt={fallbackName || 'Profile'}
className={className}
onError={() => setImageFailed(true)}
loading="lazy"
/>
);
}
return <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse"></div>;
}

  if (profileDetails.error === 'TOKEN_INVALID') {
    return (
      <Tooltip title="Connection requires refresh.">
        <div className="w-9 h-9 rounded-full bg-red-100 flex items-center justify-center">
          <i className="fa-solid fa-triangle-exclamation text-red-500"></i>
        </div>
      </Tooltip>
    );
  }

  const name =
    fallbackName ||
    profileDetails.name ||
    profileDetails.username ||
    profileDetails.profile ||
    profileDetails.business_name ||
    'Profile';

  const imageUrl = getProfileAvatarUrl(profileDetails) || fallbackImageUrl;

  if (!imageUrl || imageFailed) {
    return <FallbackAvatar name={name} className="w-9 h-9 rounded-full" />;
  }

  return (
    <img
      src={imageUrl}
      alt={name}
      className={className}
      onError={() => setImageFailed(true)}
      loading="lazy"
    />
  );
}